import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import moment from 'moment';
import ImgView from 'components/common/FileController/ImgView';
import ExcelReader from 'components/common/FileController/ExcelReader';
import { ConfigProvider, Table, Button, Input, Select, DatePicker } from 'antd';
import PaginationComp from  'components/common/PaginationComp';

import koKr from 'antd/es/locale/ko_KR';
import 'moment/locale/ko';
moment.locale('ko');

@inject('goodsInfoStore')
@observer
class GoodsList extends Component {
  state = {
    inputGdNm: '',
  };

  onPageChange = (pageIdx) => {
    // console.log('page:', page);
    this.props.goodsInfoStore.disGoodsList(pageIdx);
  };

  onSearch = () => {
    this.props.goodsInfoStore.onChangValue('gdNm', this.state.inputGdNm);
    this.props.goodsInfoStore.disGoodsList(1);
  };

  onPressEnter = (e) => {
    if (e.key === 'Enter') {
      this.onSearch();
    }
  };

  render() {
    const {
      valCondition,
      onChangValue,
      goodsList,
      pageInfo,

      onViewMode,
      disGoodsList,
      disGoodsDetail,
    } = this.props.goodsInfoStore;
    const { ceType } = this.props;
    const { 
      inputGdNm,
    } = this.state;
    const columns = [
      { title: 'No', dataIndex: 'RNUM', width: '7%', align: 'center' },
      { title: '사진', dataIndex: 'imgUrl', width: '13%', align: 'center',
        render: (item, record) => { return(
          record.gdImgUrlInfo_fileId !== undefined && record.gdImgUrlInfo_fileId !== null &&
          <ImgView
            fileInfo={{
              fileId: record.gdImgUrlInfo_fileId,
              fileName: record.gdImgUrlInfo_fileName,
              physicalName: record.gdImgUrlInfo_physicalName,
              serverSubPath: record.gdImgUrlInfo_serverSubPath,
            }}
            width={50}
            height={50}
          />
        )}
      },
      { title: '상품명', dataIndex: 'gdNm', width: '20%', align: 'center',
        render: (item, record) => {return (
          item.split(`\n`).map((text, idx)=>{
            return (
              <Fragment key={idx}>
                {text}
                {item.split(`\n`).length > idx+1 && <br />}
              </Fragment>
          )})
        )}
      },
      // { title: '상품코드', dataIndex: 'gdCd', width: 150 },
      { title: '성별', dataIndex: 'gdSex', width: '10%', align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item === "M" && <Fragment>남</Fragment>}
            {item === "F" && <Fragment>여</Fragment>}
            {item === "A" && <Fragment>공용</Fragment>}
          </Fragment>
        )}
      },
      { title: '판매가', dataIndex: 'gdPrice', width: '15%', align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item !== undefined && item !== null && item !== "" && item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </Fragment>
        )}
      },
      { title: '총 재고수량', dataIndex: 'stCntTotal', width: '10%', align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item !== undefined && item !== null && item !== "" && item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </Fragment>
        )}
      },
      { title: '품절치수 유무', dataIndex: 'gdOutOfStock', width: '10%', align: 'center',
        render: (item, record) => { return(
          item === true && <Fragment>O</Fragment>
        )}
      },
      { title: '등록일', dataIndex: 'gdMakeDate', width: '15%', align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {moment(item).format('YYYY-MM-DD')}
          </Fragment>
        )}
      },
    ];
    return (
      <Fragment>
        <div className="search-box mo_srch_box">
          <div className="search-content" style={{float:'left'}}>
            <span className="mo_srch">
              <span className="labal2">재고기간</span>
              <ConfigProvider locale={koKr}>
                <DatePicker.RangePicker
                  style={{ width: 270, marginRight: '20px' }}
                  format={'YYYY-MM-DD'}
                  allowClear={false}
                  defaultValue={[
                    moment(moment().subtract(10, 'day').format('YYYY-MM-DD').toString(), 'YYYY-MM-DD'), 
                    moment(moment().subtract(1, 'day').format('YYYY-MM-DD').toString(), 'YYYY-MM-DD')
                  ]}
                  onChange={(date)=>{
                    onChangValue('strDate', date[0].format('YYYY-MM-DD'));
                    onChangValue('endDate', date[1].format('YYYY-MM-DD'));
                    this.onSearch();
                  }}
                />
              </ConfigProvider>
            </span>
            <span className="mo_srch">
              <h4 style={{ color: 'red' }}>
                &nbsp;&nbsp;&nbsp;
                ※재고이력은 장바구니가 초기화되는(새벽3시)에 저장됩니다.
              </h4>
            </span>
          </div>
          <div className="search-button">
            <ExcelReader
              actionType={'download'}
              pageUrl={'DOWN-STOCK-LIST'}
              schInfo={valCondition}
            />
          </div>
        </div>

        <br />
        <div className="search-box mo_srch_box">
          <div className="search-content" style={{float:'left'}}>
            <span className="mo_srch">
              <span className="labal2">상품명</span> 
              <Input 
                placeholder="상품명을 입력하세요"
                value={inputGdNm}
                onChange={(e)=>this.setState({inputGdNm: e.target.value})}
                onPressEnter={this.onPressEnter}
                style={{ width: 200 }}
              />
            </span>
          </div>
          <div className="search-button">
            <Button type="primary" onClick={this.onSearch}>조회</Button>
          </div>
        </div>
        <div className="button-group">
          <Select
            style={{ width: 120 }}
            value={valCondition.recordCountPerPage}
            onChange={(value)=>disGoodsList(1, value)}
          >
            <Select.Option value={10}>10개 보기</Select.Option>
            <Select.Option value={20}>20개 보기</Select.Option>
            <Select.Option value={30}>30개 보기</Select.Option>
            <Select.Option value={40}>40개 보기</Select.Option>
          </Select>
          {(ceType === process.env.REACT_APP_TYPE_YUJIN) &&
            <div className="button-right">
              <ul>
                <li>
                  <Button 
                    type="primary"
                    onClick={()=>onViewMode('add')}
                  >추가</Button>
                </li>
              </ul>
            </div>
          }
        </div>

        <Table
          rowKey={(record)=>record.RNUM}
          columns={columns} 
          dataSource={goodsList} 
          //scroll={{ x: 1300, y:300 }}
          pagination={false}
          onRow={(record, rowIndex) => {
            return {
              onClick: e => {
                e.preventDefault();
                disGoodsDetail(record);
              },
            };
          }}
        />
        <PaginationComp 
          pageInfo={pageInfo}
          onChange={this.onPageChange}
        />
      </Fragment>
    );
  }

}

export default withRouter(GoodsList);
